import React, { KeyboardEvent } from 'react';
import { Button } from '../Button/Button';
import { Tooltip } from '../Tooltip/Tooltip';
import { VirtualizedTableRowAction, VirtualizedTableRowProps } from './VirtualizedTable.interface';

export interface VirtualizedTableActionsColumnPops {
  actions: VirtualizedTableRowAction[];
  row: VirtualizedTableRowProps;
}

export const VirtualizedTableActionsColumn: React.FC<VirtualizedTableActionsColumnPops> = ({
  actions,
  row,
}) => {
  return (
    <div role="cell" className="actionsCol cell" style={{ width: `${actions.length * 32 + 22}px` }}>
      {actions.map((action, actionIndex) => {
        const isDisabled = action.isDisabled ? action.isDisabled(row.key) : false;

        const button = (
          <Button
            key={actionIndex}
            appearance="transparent"
            disabled={isDisabled}
            icon={action.icon}
            onClick={() => action.onClick(row.key)}
            aria-label={action.ariaLabel}
            aria-disabled={isDisabled}
            onKeyDown={(event: KeyboardEvent) => {
              if (event.code === 'Enter' || event.code === 'Space') {
                event.preventDefault();
                event.stopPropagation();
                action.onClick(row.key);
              }
            }}
          />
        );

        return action.tooltip ? (
          <Tooltip
            key={actionIndex}
            content={action.tooltip}
            trigger={button}
            relationship="description"
          />
        ) : (
          button
        );
      })}
    </div>
  );
};
